var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85467 6.41634H2.76125C2.55935 6.41634 2.36572 6.34805 2.22296 6.2265C2.0802 6.10495 2 5.94009 2 5.76819V1.8793C2 1.7074 2.0802 1.54255 2.22296 1.42099C2.36572 1.29944 2.55935 1.23116 2.76125 1.23116H7.32872C7.53061 1.23116 7.72424 1.29944 7.867 1.42099C8.00976 1.54255 8.08997 1.7074 8.08997 1.8793V3.82375M6.56747 0.583008V1.8793M3.52249 0.583008V1.8793M2 3.1756H8.08997M6.18685 5.76819L6.9481 6.41634L8.47059 5.12005",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCalendar);
export default __webpack_public_path__ + "static/media/miniCalendar.16fa5be36a43ca2e5e85c310b55edb9a.svg";
export { ForwardRef as ReactComponent };